import { Component, OnInit, OnDestroy } from '@angular/core';
import { MATERIAL_IMPORTS } from '../../shared/material/material';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { AuthService } from '../../core/services/auth.service';
import Swal from 'sweetalert2';
import { UsuarioService } from '../../core/services/usuario.service';
import { Subscription } from 'rxjs';

@Component({
  standalone: true,
  selector: 'app-layout',
  imports: [
    ...MATERIAL_IMPORTS,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    MatIconModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
  ],
  templateUrl: './layout.html',
  styleUrl: './layout.scss',
})
export class Layout implements OnInit, OnDestroy {
  private usuarioSubscription?: Subscription;

  constructor(
    private router: Router,
    private authService: AuthService,
    private usuarioService: UsuarioService,
  ) {}

  user: any = null;

  ngOnInit(): void {
    this.usuarioSubscription = this.authService.usuario$.subscribe((usuario) => {
      // console.log('Layout - usuario:', usuario);

      if (usuario) {
        this.user = usuario;
      }
    });

    this.cargarUsuarioActual();
  }

  ngOnDestroy(): void {
    this.usuarioSubscription?.unsubscribe();
  }

  usuarioListo = false;

  cargarUsuarioActual(): void {
    const usuarioLocal = this.authService.getUser();

    if (!usuarioLocal?.id) {
      // console.error('No se encontró el ID del usuario.');
      this.usuarioListo = true;
      return;
    }

    this.usuarioService.obtenerUsuario(usuarioLocal.id).subscribe({
      next: (usuario) => {
        // console.log('Usuario obtenido desde backend:', usuario);

        this.user = usuario;

        this.authService.actualizarUsuarioCompleto(usuario);

        this.usuarioListo = true;
      },

      error: (error) => {
        // console.error('Error al obtener el usuario:', error);

        this.user = usuarioLocal;

        this.authService.actualizarUsuarioLocal(usuarioLocal);

        this.usuarioListo = true;
      },
    });
  }

  tieneRol(rol: string): boolean {
    return this.user?.rol?.nombre === rol;
  }

  getIniciales(): string {
    if (!this.user) {
      return '';
    }

    const nombre = this.user.nombre ?? '';
    const apellidoPaterno = this.user.apellidoPaterno ?? '';

    return `${nombre.charAt(0)}${apellidoPaterno.charAt(0)}`.toUpperCase();
  }

  cerrarSesion() {
    this.authService.logout();

    Swal.fire({
      icon: 'success',
      title: 'Sesión finalizada',
      text: 'Nos vemos pronto',
      showConfirmButton: false,
      timer: 1000,
      customClass: {
        title: 'mi-swal-title',
        htmlContainer: 'mi-swal-text',
      },
    }).then(() => {
      this.router.navigate(['/login']);
    });
  }
}
